import axios from "axios";
import { showAlert, handleRequestError } from "../utils/alert";

export default (token, email) => ({
  token: token,
  email: email,
  password: "",
  passwordConfirmation: "",
  isLoading: false,

  async submitReset() {
    if (!this.password || !this.passwordConfirmation) {
      showAlert("Preencha as senhas.", "warning");
      return;
    }

    if (this.password !== this.passwordConfirmation) {
      showAlert("As senhas não coincidem.", "warning");
      return;
    }

    this.isLoading = true;

    try {
      const response = await axios.post(
        "/api/client/auth/reset-password",
        {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        },
        {
          headers: { Accept: "application/json" },
        },
      );

      await showAlert(response.data.message, "success");

      // Redirect to login after successful reset
      window.location.href = "/client/login";
    } catch (error) {
      handleRequestError(error, "Erro ao redefinir a senha.");
    } finally {
      this.isLoading = false;
    }
  },
});
